import React from 'react';
import { Card, CardContent } from './ui/card';
import { Zap, Cloud, Code, Settings } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: <Zap className="w-8 h-8" />,
      title: t('services.modernization.title'),
      description: t('services.modernization.description'),
      features: t('services.modernization.features')
    },
    {
      icon: <Settings className="w-8 h-8" />,
      title: t('services.consulting.title'),
      description: t('services.consulting.description'),
      features: t('services.consulting.features')
    },
    {
      icon: <Cloud className="w-8 h-8" />,
      title: t('services.cloud.title'),
      description: t('services.cloud.description'),
      features: t('services.cloud.features')
    },
    {
      icon: <Code className="w-8 h-8" />,
      title: t('services.development.title'),
      description: t('services.development.description'),
      features: t('services.development.features')
    }
  ];

  return (
    <section id="servicos" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl transition-all duration-300 border-0 shadow-lg hover:-translate-y-2"
            >
              <CardContent className="p-8">
                <div className="flex items-start space-x-4">
                  <div className={`p-3 rounded-lg ${
                    index % 2 === 0 ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'
                  } group-hover:scale-110 transition-transform duration-300`}>
                    {service.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-2">
                      {service.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                          <div className={`w-2 h-2 rounded-full mr-3 ${
                            index % 2 === 0 ? 'bg-primary' : 'bg-secondary'
                          }`}></div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};